import { render, staticRenderFns } from "./TasksBoardFilters.vue?vue&type=template&id=f31dd88c&scoped=true&"
import script from "./TasksBoardFilters.vue?vue&type=script&lang=js&"
export * from "./TasksBoardFilters.vue?vue&type=script&lang=js&"
import style0 from "./TasksBoardFilters.vue?vue&type=style&index=0&id=f31dd88c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31dd88c",
  null
  
)

export default component.exports